import styled from "styled-components";
import global from "../../global";
import { Avatar, Badge, styled as mui_styled } from "@mui/material";

interface AvatarProps {
  hasNotification?: boolean;
  isMobile?: boolean;
}

export const MobileOptions = styled.div`
  @media (min-width: ${global.responsive.small.width.value}${global.responsive
      .small.width.unit}) {
    display: none;
  }
`;

export const ActionBadge = mui_styled(Badge)(
  ({ hasNotification }: AvatarProps) => ({
    cursor: hasNotification ? "pointer" : "",
  })
);

export const SmallAvatar = mui_styled(Avatar)(
  ({ hasNotification }: AvatarProps) => ({
    width: 15,
    height: 15,
    backgroundColor: "var(--error)",
    display: hasNotification ? "flex" : "none",
  })
);

export const Container = styled.div`
  padding-right: 15px;
  padding-left: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  border-bottom: 1px solid var(--light-gray) !important;
  height: 60px;
  width: 100%;
  background-color: var(--background);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 30;
  box-sizing: border-box;

  @media (max-width: ${global.responsive.small.width.value}${global.responsive
      .small.width.unit}) {
    padding-left: 12px;
    padding-right: 12px;
  }
`;



export const Language = styled.select`
  background: transparent;
  border: 1px solid var(--light-gray);
  color: var(--dark-gray);
  font-size: 16px;
  border-radius: 6px;
  padding: 4px;
`;





export const NameLabel = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: var(--dark-gray);
  margin-right: 8px;
  user-select: none;
  @media (max-width: ${global.responsive.small.width.value}${global.responsive
      .small.width.unit}) {
    display: none;
  }
`;

export const ProfileAvatar = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  width: 25px;
  height: 25px;
  background-color: var(--fixit);
  border-radius: 50%;
  color: var(--white);
  font-weight: 500;
  font-size: 10px;

  cursor: pointer;
  :hover {
    background-color: var(--success);
  }
  user-select: none;
`;

export const ButtonIcon = styled.div`
  height: 26px;
  width: 26px;
  border-radius: 50%;

  cursor: pointer;
  transition: all 0.2s;
  &.active,
  &:hover {
    background-color: rgba(152, 53, 209, 0.05);
  }
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

export const BoxNotifications = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
  width: 250px;
  height: 200px;
  position: absolute;
  right: 220px;
  top: 44px;
  border: 1px solid var(--light-gray);
  border-radius: 6px;
  padding: 6px;
  background-color: var(--white);
  list-style-type: none;
  z-index: 1;
  @media (max-width: ${global.responsive.small.width.value}${global.responsive
      .small.width.unit}) {
    right: 44px;
  }
`;

export const ProfileWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 15;
`;

export const ProfileMenuContainer = styled.div<{ $isOpen: boolean }>`
  display: ${({ $isOpen }) => ($isOpen ? "flex" : "none")};
  flex-direction: column;
  position: absolute;
  top: 40px;
  right: 0;
  width: 260px;
  background-color: var(--background);
  border: none;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  z-index: 999;
  overflow: hidden;

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    display: flex;
    position: fixed;
    top: 60px;
    bottom: 0;
    right: 0;
    width: 260px;
    border: none;
    border-left: 1px solid var(--light-gray);
    border-radius: 0;
    box-shadow: none;
    z-index: 120;
    transform: ${({ $isOpen }) => ($isOpen ? "translateX(0)" : "translateX(100%)")};
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const ProfileMenuHeader = styled.div<{ $clickable?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid var(--light-gray);
  cursor: ${({ $clickable }) => ($clickable ? "pointer" : "default")};
`;

export const ProfileHeaderTextGroup = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
`;

export const ProfileHeaderPrimaryText = styled.span`
  font-weight: bold;
  font-size: 13.5px;
  color: var(--grey-dark);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ProfileHeaderSecondaryText = styled.span`
  font-size: 12px;
  color: var(--grey-medium);
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ProfileMenuBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  width: 100%;
  padding: 8px 0;
`;

export const ProfileMenuFooter = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 8px 0 12px 0;
  border-top: 1px solid var(--light-gray);
  margin-top: auto;
`;

export const ProfileMenuButton = styled.button<{
  $isActive?: boolean;
  $locked?: boolean;
  $nonInteractive?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background-color: ${({ $isActive }) =>
    $isActive ? "var(--hover-bg-default)" : "transparent"};
  border: none;
  font-family: inherit;
  cursor: ${({ $nonInteractive }) => ($nonInteractive ? "default" : "pointer")};
  transition: all 0.2s;
  position: relative;
  border-radius: 0 20px 20px 0;
  margin: 4px 12px 4px 0;
  width: calc(100% - 12px);
  overflow: hidden;
  text-align: left;

  &::before {
    content: "";
    position: absolute;
    left: 0px;
    top: 50%;
    transform: translateY(-50%);
    height: 65%;
    width: 3px;
    background-color: var(--fixit);
    border-radius: 0 6px 6px 0;
    opacity: ${({ $isActive }) => ($isActive ? 1 : 0)};
    transition: opacity 0.2s, height 0.2s;
  }

  &:hover {
    background-color: ${({ $nonInteractive }) =>
      $nonInteractive ? "transparent" : "var(--hover-bg-default)"};

    .content svg,
    .content span {
      color: ${({ $nonInteractive }) =>
        $nonInteractive ? "var(--gray)" : "var(--fixit)"};
    }
  }

  .content {
    display: flex;
    align-items: center;
    gap: 15px;
    min-width: 0;
    flex: 1;

    svg {
      color: ${({ $isActive }) => ($isActive ? "var(--fixit)" : "var(--gray)")};
      min-width: 24px;
      transition: color 0.2s;
    }

    span {
      font-size: 14px;
      font-weight: ${({ $isActive }) => ($isActive ? "600" : "500")};
      color: ${({ $isActive }) => ($isActive ? "var(--fixit)" : "var(--gray)")};
      white-space: nowrap;
      transition: color 0.2s;
    }
  }

  .lock-badge {
    display: flex;
    align-items: center;
    margin-left: auto;
    flex-shrink: 0;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 2;

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    z-index: 110;
  }
`;

export const NavigationAction = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: auto;

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    gap: 10px;
  }

`;

export const NotificationsWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;

export const NotificationBadge = styled.div`
  position: absolute;
  top: -2px;
  right: -2px;
  background-color: var(--error);
  color: white;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: bold;
`;

export const NotificationsDropdownContainer = styled.div`
  position: absolute;
  top: 40px;
  right: -10px;
  width: 380px;
  max-height: 400px;
  background-color: white;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  z-index: 999;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: calc(100vh - 60px);
    max-height: calc(100vh - 60px);
    background-color: #f4f5f7;
    border-radius: 0;
    box-shadow: none;
    z-index: 99999;
    display: flex;
    flex-direction: column;

    animation: slideInFromRight 0.25s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  }

  @keyframes slideInFromRight {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }
`;

export const NotificationsHeader = styled.div`
  padding: 12px 16px;
  border-bottom: 1px solid var(--grey-light);
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    display: none;
  }
`;

export const MobileNotificationsHeader = styled.div`
  display: none;

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    height: 60px;
    border-bottom: 1px solid var(--light-gray);
    width: 100%;
    box-sizing: border-box;
    background-color: var(--white);
    flex-shrink: 0;
  }
`;

export const MobileHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  svg {
    cursor: pointer;
    color: var(--fixit);
    font-size: 26px;
  }
`;

export const MobileHeaderTitle = styled.h1`
  font-family: Roboto, sans-serif;
  font-size: 20px;
  font-weight: bold;
  color: var(--fixit);
  margin: 0;
`;

export const NotificationsTitle = styled.span`
  font-weight: bold;
  font-size: 14px;
  color: var(--grey-dark);
`;

export const MarkAllReadButton = styled.button`
  background: none;
  border: none;
  color: var(--fixit);
  font-size: 12px;
  cursor: pointer;
  
  &:hover {
    text-decoration: underline;
  }
`;

export const NotificationsList = styled.div`
  overflow-y: auto;
  max-height: 300px;
  display: flex;
  flex-direction: column;
  background-color: #f4f5f7; /* Fundo cinza pastél */

  /* Oculta a barra de rolagem física mantendo o scroll funcional */
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;  /* IE e Edge */
  scrollbar-width: none;  /* Firefox */

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    max-height: calc(100vh - 120px);
    flex: 1;
    padding-bottom: 80px;
  }
`;

export const NotificationItem = styled.div<{ isRead: boolean }>`
  padding: 12px 14px;
  margin: 6px 10px;
  border-radius: 10px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  cursor: pointer;
  background-color: ${(props) => (props.isRead ? 'var(--white)' : '#f4f0ff')};
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.04);
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0px 6px 12px rgba(152, 53, 209, 0.08); /* Sombra roxa bem sutil */
    background-color: ${(props) => (props.isRead ? 'var(--white)' : '#f4f0ff')};
  }
`;

export const NotificationIconWrapper = styled.div<{ color?: string; backgroundColor?: string }>`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.backgroundColor || 'var(--grey-light)'};
  color: ${(props) => props.color || 'var(--grey-dark)'};
`;

export const NotificationContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const NotificationItemTitle = styled.span<{ isRead: boolean }>`
  font-size: 13px;
  font-weight: ${(props) => (props.isRead ? 'normal' : 'bold')};
  color: var(--grey-dark);
  margin-bottom: 4px;
`;

export const NotificationItemBody = styled.span`
  font-size: 12px;
  color: var(--grey-medium);
  margin-bottom: 4px;
`;

export const NotificationTime = styled.span`
  font-size: 11px;
  font-weight: 500;
  color: var(--grey-medium);
  margin-left: auto; /* Empurra o tempo para a extrema direita */
  text-align: right;
  white-space: nowrap; /* Evita quebra de linha de termos compactos como "1min" */
  padding-top: 2px;
`;

export const EmptyNotifications = styled.div`
  padding: 24px;
  text-align: center;
  color: var(--grey-medium);
  font-size: 13px;
`;

export const LogoDesktop = styled.img`
  height: 35px;
  margin-left: 10px;
  user-select: none;
  cursor: pointer;

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    display: none;
  }
`;

export const LogoMobile = styled.img`
  height: 30px;
  margin-left: 0px;
  user-select: none;
  cursor: pointer;

  @media (min-width: ${global.responsive.small.width.value + 1}${global.responsive.small.width.unit}) {
    display: none;
  }
`;

export const TopBarOptions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  max-width: 100%;
  background-color: var(--background);
  gap: 16px;

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    gap: 10px;
  }

  img {
    padding: 8px;
    margin-right: auto;
    margin-left: 42px;
    display: none;

    @media (max-width: ${global.responsive.small.width.value}${global.responsive
        .small.width.unit}) {
      display: initial;
    }
  }
`;

export const Separator = styled.hr`
  height: 1px;
  background-color: var(--light-gray);
`;

export const CreditsWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: var(--white);
  height: 25px;
  width: max-content;
  max-width: 155px;
  padding-left: 0;
  padding-right: 6px;
  border-radius: 15px;
  border: 1px solid var(--light-gray);
  border-left: none;
  cursor: pointer;
  transition: all 0.2s;
  box-sizing: border-box;

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    max-width: 110px;
  }

  &:hover {
    border-color: var(--fixit);
    background-color: rgba(152, 53, 209, 0.05);
    p, b, span, svg {
      color: var(--fixit) !important;
    }
  }
`;







export const CreditsText = styled.p`
  font-size: 14px;
  color: var(--dark-gray);
  user-select: none;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0 4px;
  text-align: center;

  b {
    font-weight: bold;
  }

  span {
    @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
      display: none;
    }
  }
`;

export const Credits = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;

export const BuyCredits = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px;
  margin-left: 6px;
`;

export const NotificationActionText = styled.span<{ color?: string }>`
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${(props) => props.color || "var(--fixit)"};
  font-family: Roboto, sans-serif;
  font-size: 11px;
  font-weight: bold;
  margin-top: 6px;
  margin-bottom: 2px;
  width: max-content;
  user-select: none;

  svg {
    font-size: 13px;
    color: ${(props) => props.color || "var(--fixit)"} !important;
    margin: 0 !important;
  }
`;
